import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { Asset, StoreInfo } from '../models';
import { API_BASE_URL } from '../tokens/api-base-url.token';

/** The signed-in session, flattened from the smartAsset login response. */
export interface AuthResult {
  token: string;
  accountId: string;
  storeId: string;
  /** Asset id of the signed-in terminal — used as `terminalId` on store calls. */
  terminalId: string;
  storeInfo: StoreInfo;
  /** Terminal/asset display name (e.g. the kiosk name). */
  assetName: string;
}

/** PIN-based sign in against the smartAsset login endpoint. */
@Injectable({ providedIn: 'root' })
export class AuthService {
  private readonly http = inject(HttpClient);
  private readonly baseUrl = inject(API_BASE_URL);
  private readonly endpoint = `${this.baseUrl}/api/smartAsset/login`;

  /** PIN login → posts `{ lPin }` and flattens the Asset response to a session. */
  verifyPin(pin: string): Observable<AuthResult> {
    return this.http.post<Asset>(this.endpoint, { lPin: pin }).pipe(
      map((res) => ({
        token: res.token,
        accountId: res.assetData.accountId,
        storeId: res.assetData.storeInfo._id,
        terminalId: res.assetData._id,
        storeInfo: res.assetData.storeInfo,
        assetName: res.assetData.name,
      })),
    );
  }
}
